import Vue from "vue";
import Router from "vue-router";

// Containers
const TheContainer = () => import("@/containers/TheContainer");

// Views
// const Dashboard = () => import('@/views/Dashboard')

const Colors = () => import("@/views/theme/Colors");
const Typography = () => import("@/views/theme/Typography");

const Charts = () => import("@/views/charts/Charts");
const Widgets = () => import("@/views/widgets/Widgets");

// Views - Components
const Cards = () => import("@/views/base/Cards");
const Switches = () => import("@/views/base/Switches");
const Tabs = () => import("@/views/base/Tabs");
const Breadcrumbs = () => import("@/views/base/Breadcrumbs");
const Carousels = () => import("@/views/base/Carousels");
const Collapses = () => import("@/views/base/Collapses");
const Jumbotrons = () => import("@/views/base/Jumbotrons");
const ListGroups = () => import("@/views/base/ListGroups");
const Navs = () => import("@/views/base/Navs");
const Navbars = () => import("@/views/base/Navbars");
const Paginations = () => import("@/views/base/Paginations");
const Popovers = () => import("@/views/base/Popovers");
const ProgressBars = () => import("@/views/base/ProgressBars");
const Tables = () => import("@/views/tables/Tables");
const AdvancedTables = () => import("@/views/tables/AdvancedTables");
const Tooltips = () => import("@/views/base/Tooltips");

// Views - Buttons
const StandardButtons = () => import("@/views/buttons/StandardButtons");
const ButtonGroups = () => import("@/views/buttons/ButtonGroups");
const Dropdowns = () => import("@/views/buttons/Dropdowns");
const BrandButtons = () => import("@/views/buttons/BrandButtons");

// Views - Editors
const TextEditors = () => import("@/views/editors/TextEditors");
const CodeEditors = () => import("@/views/editors/CodeEditors");

// Views - Forms
const BasicForms = () => import("@/views/forms/Forms");
const AdvancedForms = () => import("@/views/forms/AdvancedForms");
const ValidationForms = () => import("@/views/forms/ValidationForms");

// Views GoogleMaps
const GoogleMaps = () => import("@/views/GoogleMaps");

// Views - Icons
const CoreUIIcons = () => import("@/views/icons/CoreUIIcons");
const Brands = () => import("@/views/icons/Brands");
const Flags = () => import("@/views/icons/Flags");

// Views - Notifications
const Alerts = () => import("@/views/notifications/Alerts");
const Badges = () => import("@/views/notifications/Badges");
const Modals = () => import("@/views/notifications/Modals");
const Toaster = () => import("@/views/notifications/Toaster");

// Views - Pages
const Page404 = () => import("@/views/pages/Page404");
const Page500 = () => import("@/views/pages/Page500");
const Login = () => import("@/views/pages/Login");
const Register = () => import("@/views/pages/Register");
const newlogin = () => import("@/views/pages/newlogin");
// Users
// const Users = () => import('@/views/users/Users')
// const User = () => import('@/views/users/User')

// Plugins
const Draggable = () => import("@/views/plugins/Draggable");
const Calendar = () => import("@/views/plugins/Calendar");
const Spinners = () => import("@/views/plugins/Spinners");

// Views - UI Kits
const Invoice = () => import("@/views/apps/invoicing/Invoice");
const Compose = () => import("@/views/apps/email/Compose");
const Inbox = () => import("@/views/apps/email/Inbox");
const Message = () => import("@/views/apps/email/Message");

//Login
const LoginPage = () => import("@/views/cattle/Auth/Login");
const RegisterPage = () => import("@/views/cattle/Auth/Register");
const Container1 = () => import("@/views/cattle/container1/TheContainer");

// const LandingPage = () => import('@/views/cattle/Auth/landingPage')

// cattle
const Dashboard = () => import("@/views/Dashboard.vue");
// Master
const species = () => import("@/views/cattle/Master/species");
const breed = () => import("@/views/cattle/Master/breed");
const tasks = () => import("@/views/cattle/Master/tasks");
const chillingcenter = () => import("@/views/cattle/Master/chillingcenter");
const zone = () => import("@/views/cattle/Master/zone");
const route = () => import("@/views/cattle/Master/route");
const society = () => import("@/views/cattle/Master/society");
const owner = () => import("@/views/cattle/Master/owner");
const sire = () => import("@/views/cattle/Master/sire");
const staff = () => import("@/views/cattle/Master/staff");
const union = () => import("@/views/cattle/Master/union");
const districts = () => import("@/views/cattle/Master/districts");
const animal = () => import("@/views/cattle/Master/animal");
const animal1 = () => import("@/views/cattle/Master/animal1");
const containermaster = () => import("@/views/cattle/Master/containermaster");

//User
const User = () => import("@/views/cattle/User/animal");

// Profile
const profile = () => import("@/views/cattle/profile/profile");

//Health
const medicinetype = () => import("@/views/cattle/Health/medicineType");
const drugmaster = () => import("@/views/cattle/Health/drugmaster");
const bodyweightentryindividual = () =>
  import("@/views/cattle/Health/bodyweightentryindividual");
const bodyscore = () => import("@/views/cattle/Health/bodyscore");
const bodyweightentrylotwise = () =>
  import("@/views/cattle/Health/body weight entry lotwise");

// Feed
const nutrientType = () =>
  import("@/views/cattle/Feed/FeedMaster/nutrientType");
const nutrients = () => import("@/views/cattle/Feed/FeedMaster/nutrients");
const feedGroup = () => import("@/views/cattle/Feed/FeedMaster/feedGroup");
const ingrediant = () => import("@/views/cattle/Feed/FeedMaster/ingrediant");
const feedFormula = () => import("@/views/cattle/Feed/FeedMaster/feedFormula");
const milkmaintance = () =>
  import("@/views/cattle/Feed/FeedMaster/milkmaintance");
const pregnancy = () => import("@/views/cattle/Feed/FeedMaster/pregnancy");

//breed
const pdEntry = () => import("@/views/cattle/Breed/Milk/pdentry.vue");
const aiService = () => import("@/views/cattle/Breed/Milk/aiService.vue");

//Rage








const tournaments = () => import("@/views/rage/tournaments.vue");
const createTournament = () => import("@/views/rage/createTournament.vue");
const editTournament = () => import("@/views/rage/editTournament.vue");
const tournamentLeaderboard = () =>
  import("@/views/rage/tournamentLeaderboard.vue");

const tournamentList_v2 = () => import("@/views/rage/tournamentList_v2.vue");
const tournamentInfo = () => import("@/views/rage/tournamentInfo.vue");

const tournamentPractice = () => import("@/views/rage/tournamentPractice.vue");
const editTournamentV2 = () => import("@/views/rage/torunament_edit_v2.vue");
const editFreeTournament = () => import("@/views/rage/editFreeTournament.vue");



const paidTournament = () => import("@/views/rage/paidTournament.vue");
const freeTournament = () => import("@/views/rage/freeTournament.vue");


// Vue.use(Router)

// export default new Router({
//   mode: 'hash', // https://router.vuejs.org/api/#mode
//   linkActiveClass: 'open active',
//   scrollBehavior: () => ({ y: 0 }),

let containers = {
  path: "/",
  component: Container1,
  name: "containers",

  children: [
    {
      path: "/RegisterPage",
      name: "RegisterPage",
      component: RegisterPage,
    },
    {
      path: "/LoginPage",
      name: "LoginPage",
      component: LoginPage,
    },

  ],
};
const routes = [
  {
    path: "/",
    redirect: "/LoginPage",
    name: "Home",
  },
  containers,
  {
    path: "/",
    // redirect: '/dashboard',
    // name: 'Home',
    component: TheContainer,
    children: [
      {
        path: "dashboard",
        name: "Dashboard",
        component: Dashboard,
      },

      {
        path: "species",
        name: "species",
        component: species,
      },
      {
        path: "breed",
        name: "breed",
        component: breed,
      },
      {
        path: "tasks",
        name: "tasks",
        component: tasks,
      },
      {
        path: "chillingcenter",
        name: "chillingcenter",
        component: chillingcenter,
      },
      {
        path: "zone",
        name: "zone",
        component: zone,
      },
      {
        path: "route",
        name: "route",
        component: route,
      },
      {
        path: "society",
        name: "society",
        component: society,
      },
      {
        path: "owner",
        name: "owner",
        component: owner,
      },
      {
        path: "sire",
        name: "sire",
        component: sire,
      },
      {
        path: "staff",
        name: "staff",
        component: staff,
      },
      {
        path: "union",
        name: "union",
        component: union,
      },
      {
        path: "districts",
        name: "districts",
        component: districts,
      },
      {
        path: "animal",
        name: "animal",
        component: animal,
      },
      {
        path: "animal1",
        name: "animal1",
        component: animal1,
      },
      {
        path: "containermaster",
        name: "containermaster",
        component: containermaster,
      },
      // health
      {
        path: "medicinetype",
        name: "medicinetype",
        component: medicinetype,
      },
      {
        path: "drugmaster",
        name: "drugmaster",
        component: drugmaster,
      },
      {
        path: "bodyweightentryindividual",
        name: "bodyweightentryindividual",
        component: bodyweightentryindividual,
      },
      {
        path: "bodyscore",
        name: "bodyscore",
        component: bodyscore,
      },
      {
        path: "bodyweightentrylotwise",
        name: "bodyweightentrylotwise",
        component: bodyweightentrylotwise,
      },

      //User

      {
        path: "user",
        name: "User",
        component: User,
      },

      //profile

      {
        path: "profile",
        name: "profile",
        component: profile,
      },

      //Feed
      {
        path: "nutrientType",
        name: "nutrientType",
        component: nutrientType,
      },
      {
        path: "nutrients",
        name: "nutrients",
        component: nutrients,
      },
      {
        path: "ingrediant",
        name: "ingrediant",
        component: ingrediant,
      },
      {
        path: "feedGroup",
        name: "feedGroup",
        component: feedGroup,
      },
      {
        path: "feedFormula",
        name: "feedFormula",
        component: feedFormula,
      },
      {
        path: "milkmaintance",
        name: "milkmaintance",
        component: milkmaintance,
      },
      {
        path: "pregnancy",
        name: "pregnancy",
        component: pregnancy,
      },
      {
        path: "pdEntry",
        name: "pdEntry",
        component: pdEntry,
      },
      {
        path: "aiService",
        name: "aiService",
        component: aiService,
      },

      {
        path: "tournaments",
        name: "tournaments",
        component: tournaments,
      },
      {
        path: "createTournament",
        name: "createTournament",
        component: createTournament,
      },
      {
        path: "editTournament/:id",
        name: "editTournament",
        component: editTournament,
      },
      {
        path: "editTournamentV2/:id",
        name: "editTournamentV2",
        component: editTournamentV2,
      },
      {
        path: "editFreeTournament/:id",
        name: "editFreeTournament",
        component: editFreeTournament,
      },
      {
        path: "tournamentLeaderboard",
        name: "tournamentLeaderboard",
        component: tournamentLeaderboard,
      },
      {
        path: "tournamentList_v2",
        name: "tournamentList_v2",
        component: tournamentList_v2,
      },
      {
        path: "tournamentPractice/:id",
        name: "tournamentPractice",
        component: tournamentPractice,
      },
      {
        path: "paidTournament/:id",
        name: "paidTournament",
        component: paidTournament,
      },
      {
        path: "freeTournament/:id/:name/:icon",
        name: "freeTournament",
        component: freeTournament,
      },
      {
        path: "tournamentInfo",
        name: "tournamentInfo",
        component: tournamentInfo,
      },
      {
        path: "theme",
        redirect: "/theme/colors",
        name: "Theme",
        component: {
          render(c) {
            return c("router-view");
          },
        },
        children: [
          {
            path: "colors",
            name: "Colors",
            component: Colors,
          },
          {
            path: "typography",
            name: "Typography",
            component: Typography,
          },
        ],
      },
      {
        path: "charts",
        name: "Charts",
        component: Charts,
      },
      {
        path: "tables",
        redirect: "/tables/tables",
        name: "Tables",
        component: {
          render(c) {
            return c("router-view");
          },
        },
        children: [
          {
            path: "tables",
            name: "Basic tables",
            component: Tables,
          },
          {
            path: "advanced-tables",
            name: "Advanced tables",
            component: AdvancedTables,
          },
        ],
      },
      {
        path: "widgets",
        name: "Widgets",
        component: Widgets,
      },
      // {
      //   path: 'users',
      //   meta: { label: 'Users' },
      //   component: {
      //     render(c) { return c('router-view') }
      //   },
      //   children: [
      //     {
      //       path: '',
      //       name: 'Users',
      //       component: Users
      //     },
      //     {
      //       path: ':id',
      //       meta: {
      //         label: 'User Details'
      //       },
      //       name: 'User',
      //       component: User
      //     }
      //   ]
      // },
      {
        path: "base",
        redirect: "/base/cards",
        name: "Base",
        component: {
          render(c) {
            return c("router-view");
          },
        },
        children: [
          {
            path: "breadcrumbs",
            name: "Breadcrumbs",
            component: Breadcrumbs,
          },
          {
            path: "cards",
            name: "Cards",
            component: Cards,
          },
          {
            path: "carousels",
            name: "Carousels",
            component: Carousels,
          },
          {
            path: "collapses",
            name: "Collapses",
            component: Collapses,
          },
          {
            path: "jumbotrons",
            name: "Jumbotrons",
            component: Jumbotrons,
          },
          {
            path: "list-groups",
            name: "List Groups",
            component: ListGroups,
          },
          {
            path: "navs",
            name: "Navs",
            component: Navs,
          },
          {
            path: "navbars",
            name: "Navbars",
            component: Navbars,
          },
          {
            path: "paginations",
            name: "Paginations",
            component: Paginations,
          },
          {
            path: "popovers",
            name: "Popovers",
            component: Popovers,
          },
          {
            path: "progress-bars",
            name: "Progress Bars",
            component: ProgressBars,
          },
          {
            path: "switches",
            name: "Switches",
            component: Switches,
          },
          {
            path: "tabs",
            name: "Tabs",
            component: Tabs,
          },
          {
            path: "tooltips",
            name: "Tooltips",
            component: Tooltips,
          },
        ],
      },
      {
        path: "buttons",
        redirect: "/buttons/standard-buttons",
        name: "Buttons",
        component: {
          render(c) {
            return c("router-view");
          },
        },
        children: [
          {
            path: "standard-buttons",
            name: "Standard Buttons",
            component: StandardButtons,
          },
          {
            path: "button-groups",
            name: "Button Groups",
            component: ButtonGroups,
          },
          {
            path: "dropdowns",
            name: "Dropdowns",
            component: Dropdowns,
          },
          {
            path: "brand-buttons",
            name: "Brand Buttons",
            component: BrandButtons,
          },
        ],
      },
      {
        path: "editors",
        redirect: "/editors/text-editors",
        name: "Editors",
        component: {
          render(c) {
            return c("router-view");
          },
        },
        children: [
          {
            path: "text-editors",
            name: "Text Editors",
            component: TextEditors,
          },
          {
            path: "code-editors",
            name: "Code Editors",
            component: CodeEditors,
          },
        ],
      },
      {
        path: "forms",
        redirect: "/forms/basic-forms",
        name: "Forms",
        component: {
          render(c) {
            return c("router-view");
          },

        },
        children: [
          {
            path: "basic-forms",
            name: "Basic Forms",
            component: BasicForms,
          },
          {
            path: "advanced-forms",
            name: "Advanced Forms",
            component: AdvancedForms,
          },
          {
            path: "validation-forms",
            name: "Form Validation",
            component: ValidationForms,
          },
        ],
      },
      {
        path: "google-maps",
        name: "Google Maps",
        component: GoogleMaps,
      },
      {
        path: "icons",
        redirect: "/icons/font-awesome",
        name: "Icons",
        component: {
          render(c) {
            return c("router-view");
          },
        },
        children: [
          {
            path: "coreui-icons",
            name: "CoreUI Icons",
            component: CoreUIIcons,
          },
          {
            path: "flags",
            name: "Flags",
            component: Flags,
          },
          {
            path: "brands",
            name: "Brands",
            component: Brands,
          },
        ],
      },
      {
        path: "notifications",
        redirect: "/notifications/alerts",
        name: "Notifications",
        component: {
          render(c) {
            return c("router-view");
          },
        },
        children: [
          {
            path: "alerts",
            name: "Alerts",
            component: Alerts,
          },
          {
            path: "badges",
            name: "Badges",
            component: Badges,
          },
          {
            path: "modals",
            name: "Modals",
            component: Modals,
          },
          {
            path: "toaster",
            name: "Toaster",
            component: Toaster,
          },
        ],
      },
      {
        path: "plugins",
        redirect: "/plugins/draggable",
        name: "Plugins",
        component: {
          render(c) {
            return c("router-view");
          },
        },
        children: [
          {
            path: "draggable",
            name: "Draggable Cards",
            component: Draggable,
          },
          {
            path: "calendar",
            name: "Calendar",
            component: Calendar,
          },
          {
            path: "spinners",
            name: "Spinners",
            component: Spinners,
          },
        ],
      },

      {
        path: "apps",
        name: "Apps",
        component: {
          render(c) {
            return c("router-view");
          },
        },
        children: [
          {
            path: "invoicing",
            redirect: "/apps/invoicing/invoice",
            name: "Invoicing",
            component: {
              render(c) {
                return c("router-view");
              },
            },
            children: [
              {
                path: "invoice",
                name: "Invoice",
                component: Invoice,
              },
            ],
          },
          {
            path: "email",
            redirect: "/apps/email/inbox",
            name: "Email",
            component: {
              render(c) {
                return c("router-view");
              },
            },
            children: [
              {
                path: "compose",
                name: "Compose",
                component: Compose,
              },
              {
                path: "inbox",
                name: "Inbox",
                component: Inbox,
              },
              {
                path: "message",
                name: "Message",
                component: Message,
              },
            ],
          },
        ],
      },
    ],
  },

  {
    path: "/pages",
    redirect: "/pages/404",
    name: "Pages",
    component: {
      render(c) {
        return c("router-view");
      },
    },
    children: [
      {
        path: "404",
        name: "Page404",
        component: Page404,
      },
      {
        path: "500",
        name: "Page500",
        component: Page500,
      },
      {
        path: "login",
        name: "Login",
        component: Login,
      },
      {
        path: "register",
        name: "Register",
        component: Register,
      },
    ],
  },
];

export default routes;
// })

// router.beforeEach((to, from, next) => {
//   const publicPages = ['/LoginPage', '/landing', '/register'];
//   const authRequired = !publicPages.includes(to.path);
//   // const loggedIn = await firebase.auth().currentUser;
//   const loggedIn = JSON.parse(localStorage.getItem(config.USER_DATA));
//   if (authRequired && !loggedIn) {
//     return next('')
//   }
//   if (!authRequired && loggedIn) {
//     return next('dashboard')
//   }
//   if (to.meta.canseesponser) {
//     if (loggedIn.accountType.toLowerCase() === 'Seller'.toLowerCase()) {
//       return next()
//     }
//     else {
//       return next('dashboard')
//     }
//   }
//   if (to.meta.canseecampaigner) {
//     if (loggedIn.accountType.toLowerCase() === 'Buyer'.toLowerCase()) {
//       return next()
//     }
//     else {
//       return next('dashboard')
//     }
//   }
//   next()
// });

// export default router;
